export default from './account-suspended-page';



// WEBPACK FOOTER //
// ./app/containers/account-suspended-page/index.js